var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-btn',_vm._b({staticClass:"SpinnerButton",on:{"click":function($event){_vm.$emit('click', $event)}}},'b-btn',_vm.$attrs,false),[_c('span',{style:({ opacity: _vm.loading ? 0 : 1 })},[_vm._t("default")],2),_vm._v(" "),(_vm.loading)?_c('spinner',{attrs:{"size":20}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3233e1d2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/SpinnerButton.vue
// module id = null
// module chunks = 